import { clamp } from 'fitify-utils/src/number'

import { StyledProgress, StyledStepsContainer } from './Stepper.Styled'
import type { StepperProps } from './Stepper.Types'

export const Stepper = ({ currentPage, totalPages }: StepperProps) => {
  const progress = clamp(
    (Math.max(1, currentPage) / Math.max(1, totalPages)) * 100
  )

  return (
    <StyledStepsContainer>
      <StyledProgress $progress={progress} />
    </StyledStepsContainer>
  )
}
